import { useNavigate } from "react-router-dom"

import Style from "./style"

import MainHeader from "widget/MainHeader"
import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetAccountList from "entity/account/useGetAccountList"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import { convertProGradeAsName } from "shared/constant/lookup/proGrade"

const UserList = () => {
    const navigate = useNavigate()

    const [accountList] = useGetAccountList()

    const sizeList = ["short", "expand", "short", "short", "short", "long", "long", "long", "medium", "short", "long"]
    const tableHeadList = ["IDX", "아이디", "카카오", "구글", "애플", "닉네임", "이름", "연락처", "프로 자격", "상태", "가입 날짜"]

    return (
        <Style.Wrapper>
            <MainHeader>사용자 계정 목록</MainHeader>
            <Search placeholder="연락처에 포함되는 글자로 검색" />

            <TStyle.TableDiv>
                <TStyle.TableRow $title>
                    {tableHeadList.map((elem, index) =>
                        <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                    )}
                </TStyle.TableRow>
                {accountList?.data?.account_list?.map((elem, index) =>
                    <TStyle.TableRow $odd={index % 2 === 1} onClick={() => navigate(`/user/${elem?.idx}/detail`)}>
                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                        <TStyle.Data $size={sizeList[1]}>{elem?.id || "-"}</TStyle.Data>
                        <TStyle.Data $size={sizeList[2]}>{elem?.is_kakao && "Yes"}</TStyle.Data>
                        <TStyle.Data $size={sizeList[3]}>{elem?.is_google && "Yes"}</TStyle.Data>
                        <TStyle.Data $size={sizeList[4]}>{elem?.is_apple && "Yes"}</TStyle.Data>
                        <TStyle.Data $size={sizeList[5]}>{elem?.nickname}</TStyle.Data>
                        <TStyle.Data $size={sizeList[6]}>{elem?.name}</TStyle.Data>
                        <TStyle.Data $size={sizeList[7]}>+{elem?.international_number} {elem?.contact}</TStyle.Data>
                        <TStyle.Data $size={sizeList[8]}>{convertProGradeAsName[elem?.pro_grade_flag]}</TStyle.Data>
                        <TStyle.Data $size={sizeList[9]}>{elem?.is_ban ? "정지" : ""}</TStyle.Data>
                        <TStyle.Data $size={sizeList[10]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                    </TStyle.TableRow>
                )}
            </TStyle.TableDiv>

            <Pagenation maxPage={accountList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default UserList